import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Building2, User, Cog, Shield, Clock, Monitor, Infinity } from 'lucide-react';

const businessBenefits = [
  {
    icon: Cog,
    title: "Automatización Total",
    description: "Automatización total de procesos de pago sin intervención manual."
  },
  {
    icon: Building2,
    title: "Control Centralizado",
    description: "Control centralizado de cuentas y movimientos desde una sola plataforma."
  },
  {
    icon: Clock,
    title: "Integración Rápida",
    description: "Integración rápida con sistemas empresariales existentes."
  },
  {
    icon: Shield,
    title: "Soporte 24/7",
    description: "Seguridad a nivel bancario y soporte especializado 24/7."
  }
];

export const BenefitsSection = () => {
  return (
    <section id="beneficios" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Business Benefits */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Beneficios Empresariales
            </h2>
            <p className="text-xl text-slate-300 max-w-3xl mx-auto">
              Potencia tu negocio con herramientas diseñadas para maximizar la eficiencia y el control financiero.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {businessBenefits.map((benefit, index) => (
              <Card key={index} className="group hover:shadow-xl transition-all duration-200 border border-slate-800 bg-slate-900">
                <CardHeader className="text-center pb-4">
                  <div className="w-14 h-14 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-yellow-500 transition-colors duration-300">
                    <benefit.icon className="h-7 w-7 text-yellow-400 group-hover:text-black transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-lg font-bold text-white group-hover:text-yellow-400 transition-colors duration-300">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <p className="text-slate-300 leading-relaxed text-sm">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Personal Benefits */}
        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 md:p-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6">
                Beneficios Personales
              </h3>
              <p className="text-lg text-slate-300 mb-8 leading-relaxed">
                NOVOPAY también es para ti. Con nuestra plataforma web, puedes enviar dinero, recibir pagos o realizar 
                transferencias en segundos. Diseñada para adaptarse a tu estilo de vida, te brinda independencia 
                y control total sobre tus finanzas personales.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
                    <Monitor className="h-4 w-4 text-black" />
                  </div>
                  <span className="text-slate-200 font-medium">Transferencias instantáneas desde la plataforma web</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
                    <Clock className="h-4 w-4 text-black" />
                  </div>
                  <span className="text-slate-200 font-medium">Disponible 24/7, sin limitaciones de horario</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
                    <User className="h-4 w-4 text-black" />
                  </div>
                  <span className="text-slate-200 font-medium">Control total adaptado a tu estilo de vida</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
                    <Infinity className="h-4 w-4 text-black" />
                  </div>
                  <span className="text-slate-200 font-medium">Sin límite de operaciones</span>
                </div>
              </div>
            </div>
            
            <div className="text-center">
              <div className="bg-black border border-slate-800 rounded-2xl p-8 shadow-lg">
                <div className="text-4xl font-bold text-yellow-400 mb-2">
                  &lt; 5 min
                </div>
                <div className="text-lg font-semibold text-white mb-2">
                  Tiempo promedio de apertura
                </div>
                <p className="text-slate-300">
                  Abre tu cuenta en menos de 5 minutos y comienza a disfrutar de la libertad financiera.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
